<mat-card
  class="media-card"
  [ngClass]="{ 'is-edit': canEditImage, 'is-selected': isSelected }"
  (click)="selectImage($event.shiftKey)"
  (dragstart)="onDragStart($event)"
>
  <div class="image-container" *ngIf="isLoading">
    <img id="loading" src="assets/images/loading.gif" />
  </div>
  <div class="image-container" *ngIf="hasError()">
    <img src="assets/images/nothumbnails.png" />
  </div>
  <div class="image-container" *ngIf="isCompleted" (click)="this.edit($event)">
    <img
      draggable="false"
      mat-card-image
      data-src="{{ inspectionImage.thumbFilePath }}"
      loading="lazy"
      [alt]="inspectionImage.fileName"
      onerror="this.src = 'assets/images/nothumbnails.png'"
      [ngStyle]="imageRotationStyle"
    />


    <svg class="image-edit-svg" viewBox="0 0 12 12 " *ngIf="isVideo()">
      <use class="none" xlink:href="assets/images/brian/iconbutton_angle_a_r_csr.svg#svg_icon_element_01"></use>
      <use class="color-bg-text" xlink:href="assets/images/brian/iconbutton_angle_a_r_csr.svg#svg_icon_background"></use>
    </svg>

    <div *ngIf="isVideo() && videoDuration !== null" class="video-duration-badge">
      {{ videoDuration | timeCount }}
    </div>

    <span *ngIf="inspectionImage.isMeasurementEnabled" class="measurable-svg">
      <svg>
        <use xlink:href="assets/icons/inspection/Measurable.svg#measurable" href="assets/icons/inspection/Measurable.svg#measurable" />
      </svg>
    </span>

    <span *ngIf="!hasError()" data-testid="mark-icon" [ngStyle]="{ 'background-color': getMarkColor(inspectionImage.mark) | async }">{{
      getFilterMark(inspectionImage.mark).code
    }}</span>
  </div>
  <mat-card-content class="image-card-content" title="{{ inspectionImage.fileName }}">
    <div *ngIf="selectModeEnabled || !hasError()" class="image-fileName" aria-label="edit" color="primary">
      {{ inspectionImage.fileName }}
    </div>
    <div *ngIf="hasError()" class="image-fileName" aria-label="edit" color="primary">
      {{ inspectionImage.fileName }}
    </div>
    <div class="image-title">
      <small>{{ inspectionImage.title }}</small>
    </div>
    <div class="image-dateTime">
      <small>{{ inspectionImage.datetime | date: "yyyy/MM/dd HH:mm:ss" }}</small>
    </div>
    <div>
      <small class="image-comment" [matTooltip]="inspectionImage.comment" matTooltipPosition="above" matTooltipClass="tooltip-overflow">
        {{ inspectionImage.comment }}
      </small>
    </div>
  </mat-card-content>
  <mat-card-footer>
    <div *ngIf="inspectionImage.hasModifiedImage || inspectionImage.hasMeasurementImage; else emptyElement">
      <small>
        <button
          mat-raised-button
          [matMenuTriggerFor]="adoptedImageMenu"
          class="adopted-image-menu-button"
          [disabled]="!canEditImage"
          (click)="$event.stopPropagation()"
        >
          {{ usedImageModeLabel() | translate }}
        </button>
        <mat-menu #adoptedImageMenu>
          <button mat-menu-item (click)="changeDiplayedImageType(UseImageType.ORIGINAL)">
            {{ "inspectionDataManagement.original" | translate }}
          </button>
          <button mat-menu-item *ngIf="inspectionImage && inspectionImage.hasModifiedImage" (click)="changeDiplayedImageType(UseImageType.RETOUCHED)">
            {{ "inspectionDataManagement.retouch" | translate }}
          </button>
          <button
            mat-menu-item
            *ngIf="inspectionImage && inspectionImage.hasMeasurementImage"
            (click)="changeDiplayedImageType(UseImageType.REMEASUREMENT)"
          >
            {{ "inspectionDataManagement.remeasurement" | translate }}
          </button>
        </mat-menu>
      </small>
    </div>
    <ng-template #emptyElement>
      <div></div>
    </ng-template>
    <div fxLayout="row" fxLayoutAlign="end">
      <button
        *ngIf="hasError()"
        mat-icon-button
        type="button"
        [disabled]="!canEditImage"
        (click)="deleteImage.emit(inspectionImage); $event.stopPropagation()"
      >
        <mat-icon class="delete-icon"> delete </mat-icon>
      </button>
      <div *ngIf="selectForReportModeEnabled" fxLayout="row">
        <evc-svg-icon size="md" [icon]="'file-export'"></evc-svg-icon>
        <app-checkbox
          id="image-checkbox"
          [checked]="isSelectedForReport"
          [isDisabled]="!havePermissionOnReport || hasError()"
          (click)="selectForReport(); $event.stopPropagation()"
        ></app-checkbox>
      </div>
    </div>
  </mat-card-footer>
</mat-card>
